import React, { useState } from 'react';
import * as Icon from 'react-feather';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem }  from 'reactstrap';
import { ConfirmDeleteCompanyContactModal } from './ConfirmDeleteModal';
import { Can } from '../../RBAC/Can';

export const CompanyContactActionsButton = props => {
    const [state, setState] = useState({
        dropdownOpen: false,
        isConfirmDeleteModalOpen: false
    });

    const toggle = () => {
        setState((prevState) => ({
            ...prevState,
            dropdownOpen: !prevState.dropdownOpen
        }));
    };

    const toggleConfirmDeleteModal = () => {
        setState((prevState) => ({
            ...prevState,
            isConfirmDeleteModalOpen: !prevState.isConfirmDeleteModalOpen
        }));        
    };

    const handleDeleteConfirmed = (entity, e) => {
        props.handleDelete(entity, e);
    };

    return (
        <>
            <Can
                perform="companies:edit"
                yes={() => (
                    <>
                        <div className="float-right">
                            <ButtonDropdown direction="left" isOpen={state.dropdownOpen} toggle={toggle} size="sm">
                                <DropdownToggle caret color="primary" size="sm">Actions</DropdownToggle>
                                <DropdownMenu>
                                    <Can
                                        perform="companies:edit"
                                        yes={() => (
                                            <>
                                                <DropdownItem onClick={(e) => props.handleEdit(props.contact, e)}> <Icon.Edit2 className="feather" />&nbsp; Edit</DropdownItem>
                                            </>
                                        )}
                                    />
                                    <Can
                                        perform="companies:delete"
                                        yes={() => (
                                            <>
                                                <DropdownItem divider />
                                                <DropdownItem onClick={() => toggleConfirmDeleteModal()}> <Icon.Trash2 className="feather" />&nbsp; Delete</DropdownItem>
                                            </>
                                        )}
                                    />
                                </DropdownMenu>
                            </ButtonDropdown>
                        </div>

                        <ConfirmDeleteCompanyContactModal
                            isOpen={state.isConfirmDeleteModalOpen}
                            toggle={toggleConfirmDeleteModal}
                            handleConfirm={handleDeleteConfirmed}
                            contact={props.contact}
                        />
                    </>
                )}
            />          
        </>
    );
}
